// extracted by mini-css-extract-plugin
export default {"external":"a61O24","wrapper":"b61O24","overview":"c61O24","headlines":"d61O24"};